import { render, staticRenderFns } from "./TabContentComponent.vue?vue&type=template&id=24cf82b4&"
import script from "./TabContentComponent.vue?vue&type=script&lang=js&"
export * from "./TabContentComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports